import React from 'react';

import PulseScene from 'views/scenes/product/pulse/PulseScene';
import {SEO, translate} from 'views/module';

const Pulse = () => {
  return (
    <main >
      <SEO
        title={translate('pulse.Meta.Title')}
        description={translate('pulse.Meta.Description')}
      />
      <PulseScene />
    </main>
  );
};

export default Pulse;
